export const CONTROL_PLANE_HOST = process.env.REACT_APP_CONTROL_PLANE_HOST || 'localhost:3003';
export const CONTROL_PLANE_MODULE = process.env.REACT_APP_CONTROL_PLANE_MODULE || 'sweepr-control';
export const SPACETIMEDB_PROTOCOL = process.env.REACT_APP_SPACETIMEDB_PROTOCOL || 'ws';
export const WORKER_URL = process.env.REACT_APP_WORKER_URL || '';
